import React, { useState } from "react";
import "./Tabs.css";

const ConditionsForParticipation = () => {
  const [activeTab, setActiveTab] = useState("conditions");

  return (
    <div className="rules-container">
      <h1 className="rules-title">Conditions for participation</h1>

      {/* Navigation Tabs */}
      <div className="rules-tabs">
        <button
          className={`tab ${activeTab === "conditions" ? "active" : ""}`}
          onClick={() => setActiveTab("conditions")}
        >
          GENERAL CONDITIONS
        </button>
        <button
          className={`tab ${activeTab === "required" ? "active" : ""}`}
          onClick={() => setActiveTab("required")}
        >
          REQUIRED EQUIPMENT
        </button>
        <button
          className={`tab ${activeTab === "recomended" ? "active" : ""}`}
          onClick={() => setActiveTab("recomended")}
        >
          RECOMENDED EQUIPMENT
        </button>
      </div>

      {/* Content */}
      <div className="rules-content">
        {activeTab === "conditions" && (
          <div className="content">
            <img
              src="./gallery/VLD_8798.jpg"
              alt="Offroad"
              className="content-image"
              loading="lazy"
            />
            <p>
              All competing vehicles must be registered for driving. In the
              TROPHY and ADVENTURE class, only the driver and front passenger
              can ride. At START, each vehicle must have a starting number
              affixed on both sides of the vehicle, in the front door, in a
              conspicuous place. The use of agricultural vehicles and
              agricultural equipment (tractors, motor cultivators, tractor
              tires, tracks, chainsaws, etc.) is prohibited. It is strictly
              forbidden to consume alcohol on the course, as well as while
              driving.
            </p>
          </div>
        )}
        {activeTab === "required" && (
          <div className="content">
            <p>
              TROPHY class: front winch (preferably rear winch) electrical,
              hydraulic, mechanical helmet (driver and front passenger) roll bar
              Belt, at least at three points Mileage meter or trip master wood
              protective tape First help bar and additional tool for towing fire
              extinguisher ADVENTURE class: front electric winch helmet (driver
              and front passenger) roll bar Belt, at least at three points First
              help bar and an additional tool for towing fire extinguisher
              off-road tires required for both racing classes, for Adventure
              class max tire height 88cm TOURIST class ZOBS equipment
            </p>
          </div>
        )}
        {activeTab === "recomended" && (
          <div className="content">
            <p>
              means of communication (radios, mobile phones) compass protective
              gloves drinking water wheel the basic tool bindings for tethering
              or retraction
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConditionsForParticipation;
